import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LicenseState } from '@store/reducers';

export const selectLicenseState = createFeatureSelector<LicenseState>('license');

export const selectLicenseLoading = createSelector(
  selectLicenseState,
  (state) => state.loading
);

export const selectLicenseList = createSelector(
  selectLicenseState,
  (state) => state.licenseList
);

export const selectLicenseError = createSelector(
  selectLicenseState,
  (state) => state.error
);

export const selectLicenseEditMode = createSelector(
  selectLicenseState,
  (state) => state.editMode
);

export const selectLicenseIsEditing = createSelector(
  selectLicenseState,
  (state) => state.isEditing
);

export const selectLicenseForm = createSelector(
  selectLicenseState,
  (state) => state.licenseForm
);

export const selectLicenseId = createSelector(
  selectLicenseState,
  (state) => state.licenseId
);

export const selectLicense = createSelector(
  selectLicenseState,
  (state) => state.license
);
